import { ActivatedRouteSnapshot, CanActivate } from '@angular/router';
import { map, Observable } from 'rxjs';

import { UserEntitlementService } from './user-entitlement.service';
import { Entitlement } from '../models/entitlement.constants';

export abstract class EntitlementBackedRouteActivateGuardService implements CanActivate {
    protected constructor(private readonly userEntitlementsService: UserEntitlementService, private readonly entitlement: Entitlement) {}

    canActivate(route: ActivatedRouteSnapshot): Observable<boolean> | Promise<boolean> | boolean {
        const clientCode = route.parent?.paramMap.get('clientCode');
        if (!clientCode) {
            return false;
        }

        return this.userEntitlementsService.fetchUserEntitlements(clientCode)
            .pipe(map((userEntitlements) => userEntitlements.hasPermission(this.entitlement)));
    }
}
